import React from "react";
import {paramSettingsService} from "../../jwt/_services/hotel/paramsSettingsService";

export const xwitchLogProvider = {
    getOptions
}

async function getOptions(customFilter) {
    try {
        const listItems = await paramSettingsService.search(0,1000, {item:{ps_key:'xwitch_log_error_type'}} );

        const data = listItems?.data[0]?.ps_value_max;
        const JSONData = JSON.parse(data);
        
         return Object.values(JSONData).map(({ code, label }) => ({
                id: code,
                value: `${code} - ${label}`,
                label: <label>{`${code} - ${label}`}</label>,
            })
        );

    } catch (error) {
        console.log(error.message)
    }
}